import React from "react"
import { Link } from "gatsby"
import Modal from "react-modal"
import styled from "styled-components"
import { theme } from "Theme"

import { Agenda } from "Components"

const { fontSize } = theme

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  render() {
    const { props } = this
    const { title, subtitle, agendas, banner, isOpen, closeModal, onAfterOpen, onRequestClose } = props
    // console.log("AGENDA: ", agendas)
    const { loading } = this.state
    return (
      <Modal
        id="modalAgenda"
        contentLabel="modalAgenda"
        closeTimeoutMS={400}
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}>
        {!loading && (
          <>
            {/* <HeaderImage title={`${title}`} subtitle={subtitle} image={banner} /> */}
            <button className="btn-close" onClick={closeModal}>
              X
            </button>
          </>
        )}

        <Agenda title="Schedule" schedule={agendas} subtitle={``} />
      </Modal>
    )
  }
}
